import axios from 'axios';
// Mail API is same-origin (nginx -> saas API). Relative base so calls resolve to the
// current host (e.g. virgo.astraealaw.com/api/...), unless an explicit override is set.
const getMailApiBaseUrl = () => {
  return process.env.REACT_APP_MAIL_API_URL || '';
};

const mailApi = axios.create({
  baseURL: getMailApiBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// Update base URL when tenant changes
export const updateMailApiBaseUrl = () => {
  mailApi.defaults.baseURL = getMailApiBaseUrl();
};

// Request interceptor to add auth token and update base URL dynamically
mailApi.interceptors.request.use(
  (config) => {
    // Always use the current tenant API URL
    const currentUrl = getMailApiBaseUrl();
    if (currentUrl !== mailApi.defaults.baseURL) {
      mailApi.defaults.baseURL = currentUrl;
      config.baseURL = currentUrl;
    }

    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
mailApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default mailApi;
